export const PascalGameTypeEnum = {
  Single: 0,
  Singles: 1,
  Multiple: 2,
};

export const PascalGameTypeViewEnum = {
  [PascalGameTypeEnum.Single]: 'Single',
  [PascalGameTypeEnum.Singles]: 'Singles',
  [PascalGameTypeEnum.Multiple]: 'Multiple',
};

export const GoldenRaceGameGroupTypeEnum = {
  Generic: 'Generic',
  Sport: 'Sport',
  Lottery: 'Lottery',
  Racing: 'Racing',
};
